import { render } from "./FixedHeaderTable.vue?vue&type=template&id=5e41955c"
import script from "./FixedHeaderTable.vue?vue&type=script&lang=ts"
export * from "./FixedHeaderTable.vue?vue&type=script&lang=ts"
script.render = render

export default script